export default "__VITE_ASSET__C70O$7Ju__"